<template>
    <div class="cta-banner">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-6 mb-5 mb-md-0 text-center text-md-left">
                    <h3 class="mb-0">CONTACTEZ-NOUS</h3>
                    <a href="tel:+33233253368">
                        <h1>02 33 25 33 68</h1>
                    </a>
                </div>
                <div class="col-12 col-md-6 text-center text-md-right">
                    <h3 class="mb-0">Le devis est gratuit !</h3>
                    <p class="mb-0">
                        Contactez Blanchard pour nous expliquez vos besoins, nous nous efforcerons de trouver une solution adaptée à votre projet.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CTABanner"
}
</script>

<style lang="scss" scoped>
    .cta-banner {
        padding: 100px 0;
        background-color: $primary;
        color: $white;

        a {
            color: inherit;

            &:hover {
                color: #212529;
                text-decoration: none;
            }
        }

        @media screen and (max-width: $tablet) {
            h1 {
                font-size: 44px;
            }
        }

        @media screen and (max-width: $mobile) {
            h1 {
                font-size: 46px;
            }
        }
    }
</style>